// import { ProSidebarProvider } from "react-pro-sidebar";
// import SidebarPro from "./SidebarPro";
// import "../../scss/reactSidebar.scss";

// const ReactSidebar = ({
//   dineinTabs,
//   paymentStatus,
//   splitDetails,
//   toggleArrow,
//   arrow,
//   startBillNum,
//   endBillNum,
//   FoodBeverageSum,
//   outlet,
//   baseUrl,
//   token,
//   creditOrders,
//   discountOrders,
// }) => {
//   return (
//     <ProSidebarProvider>
//       <SidebarPro
//         dineinTabs={dineinTabs}
//         paymentStatus={paymentStatus}
//         splitDetails={splitDetails}
//         toggleArrow={toggleArrow}
//         arrow={arrow}
//         startBillNum={startBillNum}
//         endBillNum={endBillNum}
//         FoodBeverageSum={FoodBeverageSum}
//         outlet={outlet}
//         baseUrl={baseUrl}
//         token={token}
//         disconutOrders={discountOrders}
//         creditOrders={creditOrders}
//       />
//     </ProSidebarProvider>
//   );
// };

// export default ReactSidebar;







import SidebarPro from "./SidebarPro";

const ReactSidebar = ({
  dineinTabs,
  paymentStatus,
  splitDetails,
  toggleArrow,
  arrow,
  startBillNum,
  endBillNum,
  FoodBeverageSum,
  outlet,
  order,
  startDate,
  endDate,
  url,
  token
}) => {
  const discountOrders = order.filter(
    item => Number(item.DiscountAmt) > 0
  );

  const creditOrders = order.filter(
    item => item.PaymentMode === "Credit"
  );

  return (
    <SidebarPro
      dineinTabs={dineinTabs}
      paymentStatus={paymentStatus}
      splitDetails={splitDetails}
      toggleArrow={toggleArrow}
      arrow={arrow}
      startBillNum={startBillNum}
      endBillNum={endBillNum}
      FoodBeverageSum={FoodBeverageSum}
      outlet={outlet}
      discountOrders={discountOrders}
      creditOrders={creditOrders}
      startDate={startDate}
      endDate={endDate}
      url={url}
      token={token}
    />
  );
};

export default ReactSidebar;